import React from 'react'
import { Routes } from '../../constants/RouteConstants'
import { Link } from 'react-router-dom'

const PageNotFound = () => {
    return (
        <section className="page_404 text-center">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <h1 className="text_404">404</h1>
                        <div className="four_zero_four_bg">

                        </div>
                        <div className="contant_box_404">
                            <p className='txt_not_found'>The page you are looking for was not found.</p>
                            <Link to={Routes?.Dashboard} className="link_404">Go to Dashboard</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PageNotFound